module.exports = __webpack_public_path__ + "static/fredbn-19b638971290478c5d2755476a373b60.jpeg";